import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { getConfig } from '@cian/config/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';
import { TDropdownType } from '../../dropdown_menu/interfaces';
import { DropdownMenuContainer } from '../../dropdown_menu/container';
import { ISpecialPromoLinkData } from '../../../app/models/promo';
import { TopMenuContainer } from '../../../shared/containers/TopMenuContainer';

export interface IInitDropdownMenus {
  headerData?: IHeaderV1Schema;
  newHeaderEnabled?: boolean;
}

export const initializeDropdownMenus = (params: IInitDropdownMenus) => {
  const { newHeaderEnabled } = params;
  if (!newHeaderEnabled) {
    const dropdowns: TDropdownType[] = ['rent', 'sale', 'newbuildings', 'commercial', 'mortgage'];
    const data = window.__header_dropdown_menus_data__;
    const logger = getLogger();

    dropdowns.forEach(name => {
      const container = document.querySelector(`[data-fh-menu-dropdown-${name}] > div`);
      hydrate(
        <ErrorLogComponent logger={logger}>
          <DropdownMenuContainer {...data[name]} />
        </ErrorLogComponent>,
        container,
      );
    });
  }
};

export const initializeNewTopMenu = (params: IInitDropdownMenus) => {
  const { headerData, newHeaderEnabled } = params;
  if (newHeaderEnabled) {
    const data = window.__header_dropdown_menus_data__;
    const container = document.getElementById('bottom-menu-titles');
    const specialPromoLinkData: ISpecialPromoLinkData = window.__header_special_promo_link_data__;

    if (container && headerData) {
      hydrate(
        <ErrorLogComponent logger={getLogger()}>
          <TopMenuContainer
            dropdownMenusData={data}
            specialPromoLinkData={specialPromoLinkData}
            headerData={headerData}
            activeKey={getConfig().get<string>('section') as string}
          />
        </ErrorLogComponent>,
        container,
      );
    }
  }
};
